import { render, staticRenderFns } from "./df-promotion-card.vue?vue&type=template&id=243c8618&"
import script from "./df-promotion-card.ts?vue&type=script&lang=js&"
export * from "./df-promotion-card.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports